import { useRef } from "react";
import { useSwiperSlide } from "swiper/react";

export default function App(props) {
  const video = useRef();
  const swiperSlide = useSwiperSlide();

  if (!swiperSlide.isActive) {
    return <></>;
  }

  const videoPause = () => {
    const videoEle = video.current;

    if (videoEle !== undefined && videoEle !== null) {
      videoEle.pause();
    }
  };

  if (props.rootSwiper !== undefined && props.rootSwiper !== null) {
    props.rootSwiper.on("slideChange", videoPause());
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <img
        style={{
          position: "absolute",
          top: "36px",
          left: "50%",
          transform: "translate(-50%, -0%)",
        }}
        src="images/03/01/subtitle.png"
      ></img>
      {/* <img
        style={{
          position: "absolute",
          top: "167px",
          left: "50%",
          transform: "translate(-50%, -0%)",
        }}
        src="images/03/01/context_1.png"
      ></img> */}
      <img
        style={{
          position: "absolute",
          top: "796px",
          left: "292px",
        }}
        src="images/common/video_guide_white.png"
      ></img>
      <video
        ref={video}
        controls
        style={{
          position: "absolute",
          filter: "drop-shadow(10.607px 10.607px 15px rgba(0,0,0,0.35))",
          border: "1px solid #ffffff",
          width: "960px",
          height: "540px",
          top: "228px",
          left: "117px",
          background: "#000",
        }}
        poster="images/03/01/thumbnail.png"
      >
        <source src="media/video/COM_M2_3_1.mp4" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </div>
  );
}
